import { Path, Rect, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Rect x="4" y="9" width="11" height="6" fill="currentColor" stroke="none" />
		<Path d="M19.25 20V4" vectorEffect="non-scaling-stroke" />
	</SVG>
);
